import React, { Component } from 'react';
import { source } from 'react-aim';
import { Popup } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
const style = {
  borderRadius: 0,
  opacity: 0.8,
  padding: '6px'
}

@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name)
  }
})
export default class extends Component {

  render() {
    return (
      <li>
        <Popup trigger={<a className={this.props.className} onClick={this.props.action} >
          {this.props.name}
        </a>}
          content={this.props.name}
          position='right center'
          style={style}
          inverted
        />

      </li>

    );
  }
}